import axios from "axios";
import { SERVER_URL } from "../socket";

export async function fetchMailbox(folder, headers) {
  const res = await axios.get(`${SERVER_URL}/api/mail/${folder}`, { headers });
  return Array.isArray(res.data?.mails) ? res.data.mails : [];
}


export async function markMailAsRead(mailId, headers) {
  await axios.patch(`${SERVER_URL}/api/mail/${mailId}/read`, {}, { headers });
}

export async function markMailAsUnread(mailId, headers) {
  await axios.patch(`${SERVER_URL}/api/mail/${mailId}/unread`, {}, { headers });
}

/* ---------------- DELETE (single) ---------------- */

export async function deleteMail(mailId, headers) {
  const res = await axios.delete(`${SERVER_URL}/api/mail/${mailId}`, { headers });
  return res.data;
}

/* ---------------- DELETE (bulk) ✅ ---------------- */

export async function deleteMailsBulk(ids, headers) {
  const res = await axios.post(
    `${SERVER_URL}/api/mail/bulk-delete`,
    { ids },
    { headers }
  );
  return res.data;
}
export async function moveMail(mailId, folder, headers) {
  const res = await axios.patch(
    `${SERVER_URL}/api/mail/${mailId}/folder`,
    { folder },
    { headers }
  );
  return res.data;
}

export async function moveMailsBulk(ids, folder, headers) {
  const res = await axios.post(
    `${SERVER_URL}/api/mail/bulk-move`,
    { ids, folder },
    { headers }
  );
  return res.data;
}

export async function sendMail(payload, headers) {
  const res = await axios.post(`${SERVER_URL}/api/mail`, payload, { headers });
  return res.data;
}

export async function saveDraft(payload, headers) {
  const body = { ...(payload || {}), folder: "draft" };
  const res = await axios.post(`${SERVER_URL}/api/mail`, body, { headers });
  return res.data;
}

export async function updateDraft(mailId, payload, headers) {
  const body = { ...(payload || {}) };
  const res = await axios.put(`${SERVER_URL}/api/mail/${mailId}`, body, { headers });
  return res.data;
}

export async function fetchMailStats(headers) {
  const res = await axios.get(`${SERVER_URL}/api/mail/stats`, { headers });
  return res.data || {};
}

export async function fetchMailsByStatus(status, headers) {
  const res = await axios.get(`${SERVER_URL}/api/mail/status/${encodeURIComponent(status)}`, { headers });
  return Array.isArray(res.data?.mails) ? res.data.mails : [];
}

export async function updateMailStatus(mailId, mailStatus, headers = {}) {
  const res = await axios.patch(
    `${SERVER_URL}/api/mail/${mailId}/status`,
    { mailStatus },
    { headers } // always object now
  );
  return res.data;
}
